package game.entity

import game.Game
import game.Room

enum class ShardValue(val value: Int, val sprite: String,  val pickupSound: String) {
    Small(1, "small-shard", "shard-pickup-1"),
    Medium(5, "medium-shard", "shard-pickup-2"),
    Large(15, "large-shard", "shard-pickup-3")
}

class Shard(private val shardValue: ShardValue): Entity() {
    override fun onInit(game: Game, room: Room) {
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        if (game.player.lens) {
            val sound = game.getSound(shardValue.pickupSound)

            game.playSound(sound)

            game.shards += shardValue.value

            room.removePermanently(game, this)
        }

        return true
    }

    override fun onTick(game: Game, room: Room) {
        if (game.player.lens && sprite == null) {
            sprite = game.getSpriteById(shardValue.sprite)
        }
    }
}